// Created/Updated by Developer - 05/01/2024

import { Component } from '@angular/core'
import { BaseController } from './base.controller';
import { Action,ApiResponseModel,AuthService,CtButtonComponent,CtColumnComponent,CtFormComponent,CtHeaderComponent,CtInputNumberComponent,CtInputTextComponent,CtMessageContainerComponent,CtRowComponent,CtViewComponent,EntityField, HttpService, InputBaseComponent, UtilService } from 'components';
import { Router } from '@angular/router';
import { defaultIfEmpty, take } from 'rxjs/operators';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { ReturnStatement } from '@angular/compiler';

@Component({
	selector: 'av-vi13',
	template: `<div [id]="getId()" #target><div>`
})

export class AvVi13 extends BaseController {

	public docIdenAso: number;
	public numPat: number;

	constructor(private authService: AuthService,private router : Router) {
		super();
		super.setViewCode('AV_VI13');
	}

	ngOnDestroy(): void {
	}
	ngOnInit(): void {
		this.setTelefonoUnable();
	}


	/* ---------------------- CONTROLLER LOGIC ------------------- */

	public setAsocFromStore(action: Action): void {
		const numCliente: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[0]);
		const docIdentificacionAso: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[1]);
		const numClienteOficial: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[2]);

    let organizationID = this.authService.loggedUser.user.organization;
    if (!organizationID) {
      organizationID = 0;
    }
    numCliente.setValue(organizationID.toString());
    numCliente.setOldValue(organizationID.toString());

		numClienteOficial.setValue(this.authService.loggedUser.user.num_cliente_sigma);
		docIdentificacionAso.setValue(this.authService.loggedUser.user.user_code);
	  }

	private setTelefonoUnable(): void {
		 const inputNumeroInst: CtInputNumberComponent = this.utilService.getComponentRef('ctinCtInputNumber_inputpat');
		 let numPatrono = this.authService.loggedUser.user.organization.toString();
		 if(numPatrono == '' || numPatrono == null){
			inputNumeroInst.setReadOnly(true);
		 }else {
			inputNumeroInst.setReadOnly(false);
		 }
	}
	
	public setSummaryInfo(action: Action) {
		let form: CtFormComponent = this.utilService.getComponentRef(action.conditionParams[0]);
		let formContacto1: CtFormComponent = this.utilService.getComponentRef(action.conditionParams[1]);
		let formContacto2: CtFormComponent = this.utilService.getComponentRef(action.conditionParams[2]);
		let numClienteInput: CtInputNumberComponent = this.utilService.getComponentRef(action.conditionParams[3]).getValue();
		let docIdInput: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[4]).getValue();
		const inputNumeroInst: CtInputNumberComponent = this.utilService.getComponentRef('ctinCtInputNumber_inputpat');


		this.getAsociadoInfo(numClienteInput, docIdInput).subscribe({
		  next: (response: ApiResponseModel) => {
			this.utilService.setAdnToAnyComponent(action.conditionParams[0], response['Data']);	
			this.utilService.setAdnToAnyComponent(action.conditionParams[1], response['Data']);		
			this.utilService.setAdnToAnyComponent(action.conditionParams[2], response['Data']);		
			let data = response['Data']
			let telefonoPat = this.utilService.getStringAttribute('DES_LOCALIZACION', data[0].ArrayEntities.List)
			if(telefonoPat == "" || telefonoPat === null){
				inputNumeroInst.setReadOnly(true);
			}
		  },
		  error: (err: any) => {
			this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', err.description,
			  true, 'Aceptar', 'Cancelar');

		  }
		});
	}

	private validacionCampos(): boolean {
		const inputCorreo = this.utilService.getComponentRef('txtCtInputText_CORREO');
		const inputNumeroPersonal = this.utilService.getComponentRef('ctinCtInputNumber_Celular');
		const inputNumeroInst = this.utilService.getComponentRef('ctinCtInputNumber_inputpat');
		if(this.isFieldEmpty(inputCorreo) || this.isFieldEmpty(inputNumeroPersonal)){
			this.messageValidationForm('Por favor, complete todos los campos obligatorios para guardar los cambios. Los campos marcados con * son requeridos.')
			return false;
		}else{

			if(this.validateField(inputCorreo) && this.validateField(inputNumeroPersonal) && this.validateField(inputNumeroInst)){
				return true;
			}
			return false;
		}
	}

	private validateField(element: InputBaseComponent): boolean {
		switch (element.getModelId()) {
		  case 'CORREO':
			if (!this.validationEmail(element)) {
			  this.messageValidationForm('El dato ingresado para correo electrónico parece incorrecto o incompleto. Por favor, revise y corrija este dato para continuar.');
			  return false;
			}
			break;
		  case 'TELEFONO':
			if (element.getValue().length < 8) {
			  this.messageValidationForm('El dato ingresado para teléfono personal parece incorrecto o incompleto. Por favor, revise y corrija este dato para continuar.');
			  return false;
			}
			break;
		  case 'DES_LOCALIZACION':
			if (element.getValue() !== null && element.getValue().length > 0 && element.getValue().length < 8) {
			  this.messageValidationForm('El dato ingresado para teléfono institucional parece incorrecto o incompleto. Por favor, revise y corrija este dato para continuar.');
			  return false;
			}
			break;
		}
	  
		return true;
	  }

	private validationEmail(element): boolean{
		const pattern: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		  if(pattern.test(element.getValue())){
			return true;
		  }else return false;
		}

	private isFieldEmpty(element: InputBaseComponent): boolean {
		return element.getValue() === '' || element.getValue() === null;
	}

	private messageValidationForm(message): void {
		this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', message ,true, 'Aceptar', 'Cancelar');
	  }
	
	

	private setSummaryAsociadoMetadata(numClienteInput: CtInputNumberComponent, docIdInput : CtInputTextComponent): any {
	
	
		return {
		  "Type": 1,
		  "UserCode": "SVA",
		  "Source": "SVA",
		  "Conditions":
		  {
			"Data": [
			  {
				"Name": "NUM_PATRONO",
				"Alias": "NUM_PATRONO",
				"Value": numClienteInput
	
			  },
			  {
				"Name": "DOC_IDENTIFICACION",
				"Alias": "DOC_IDENTIFICACION",
				"Value": docIdInput
			  }
	
			]
		  },
		  "Data": []
		}
	}
	
	

	public getAsociadoInfo(numClienteInput: CtInputNumberComponent, docIdInput : CtInputTextComponent): Observable<any> {
		const requestData: any = this.setSummaryAsociadoMetadata(numClienteInput, docIdInput);
		return this.httpService.post(HttpService.ENDPOINT + '/api/process/CLIENTES/SER_RET_MI_INFO_CLIE', requestData);
	}

		
	/* -------------------- END CONTROLLER LOGIC ----------------- */

}
